<div class="view-btns">
  <button class="btn btn-prev">Anterior</button>
  <button class="btn btn-next">Próximo</button>
</div>

